// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentProviderChargeBackFeesSettingsController  = function ($scope, $location, $routeParams, $http, PaymentProviderSettings, $rootScope) {

    function getPspSettingsPage(provider) {
        var basePath = '';
        switch (provider) {
        case "PayOne":
                basePath = 'partials/payment-providers-settings/settings-payone-edit.html' + $rootScope.linkVersion;
            break;
        case "FakeProvider":
                basePath = 'partials/payment-providers-settings/settings-fakeprovider-edit.html' + $rootScope.linkVersion;
            break;
        case "InvoicePayment":
                basePath = 'partials/payment-providers-settings/settings-invoicePayment-edit.html' + $rootScope.linkVersion;
            break;
        case "PayPal":
                basePath = 'partials/payment-providers-settings/settings-paypal-edit.html' + $rootScope.linkVersion;
            break;
        case "Stripe":
                basePath = 'partials/payment-providers-settings/settings-stripe-edit.html' + $rootScope.linkVersion;
            break;
        case "StripeV2":
            basePath = 'partials/payment-providers-settings/settings-stripev2-edit.html' + $rootScope.linkVersion;
            break;
        case "Unzer":
            basePath = 'partials/payment-providers-settings/settings-unzer-edit.html' + $rootScope.linkVersion;
            break;
        case "UnzerV2":
            basePath = 'partials/payment-providers-settings/settings-unzerv2-edit.html' + $rootScope.linkVersion;
            break;            
        case "GoCardless":
                basePath = 'partials/payment-providers-settings/settings-gocardless-edit.html' + $rootScope.linkVersion;
            break;
        case "Adyen":
                basePath = 'partials/payment-providers-settings/settings-adyen-edit.html' + $rootScope.linkVersion;
                break;
        case "ThirdPartyIntegration":
                basePath = 'partials/payment-providers-settings/settings-external-edit.html' + $rootScope.linkVersion;
                break;
        case "Mollie":
            basePath = 'partials/payment-providers-settings/settings-mollie-edit.html' + $rootScope.linkVersion;
            break;
        case "SepaXml":
            basePath = 'partials/payment-providers-settings/settings-sepaxml-edit.html' + $rootScope.linkVersion;
            break;
        default:
            break;
        }
        return basePath + $rootScope.linkVersion;
    }

    if ($routeParams.paymentProvider) {
        $scope.settings = PaymentProviderSettings.get({ paymentProvider: $routeParams.paymentProvider, paymentProviderExternalId: $routeParams.paymentProviderExternalId });
        $scope.provider = $routeParams.paymentProvider;
        $scope.paymentProviderExternalId = $routeParams.paymentProviderExternalId;
        $scope.settingsPage = getPspSettingsPage($routeParams.paymentProvider);
    }
    else {
        $scope.providers = PaymentProviderSettings.query();
    }

    $scope.save = function () {
        $scope.settings.$update({ paymentProvider: $routeParams.paymentProvider }, function () {
            $location.path("/settings/payment-providers-list");
        });
    };

    $scope.saveList = function () {
        for (var i = 0; i < $scope.providers.length; i++) {
            (function () { // required to avoid late binding of 'item'
                var item = $scope.providers[i];
                if (typeof item.Status != 'undefined') {
                    $http({
                        method: "POST",
                        url: baseUrl + "api/v1/paymentProviderSettings/" + item.PaymentProvider + "/status",
                        cache: false,
                        data: item.Status,
                        headers: { "Content-Type": "application/json" }
                    }).then(
                    function (response) {
                        // CAREFUL: This is JS, which uses LATE BINDING!!! 'item' doesn't refer to the value it was assigned before!!
                        item.Status = response.data;
                        item.saved = true;
                    },
                   function (data) {
                        item.Status = data;
                    });
                }
            })();
        }
    };

    var refreshStates = function (settings, refreshFn) {
        for (var i = 0; i < $scope.providers.length; i++) {
            (function () { // required to avoid late binding of 'item'
                var item = $scope.providers[i];
                if (typeof item.Status != 'undefined') {
                    if (item.PaymentProvider != settings.PaymentProvider)
                        refreshFn(item.Status);
                }
            })();
        }
    };

    $scope.refreshCCStates = function (settings) {
        refreshStates(settings, function (status) { status.CreditCardActive = false; });
    };

    $scope.refreshDebitStates = function (settings) {
        refreshStates(settings, function (status) { status.DebitActive = false; });
    };

    $scope.refreshOnAccountStates = function (settings) {
        refreshStates(settings, function (status) { status.OnAccountActive = false; });
    };

    $scope.refreshBetalingsserviceStates = function (settings) {
        refreshStates(settings, function (status) { status.BetalingsserviceActive = false; });
    };
    
    $scope.refreshAutogiroStates = function (settings) {
        refreshStates(settings, function(status) { status.AutogiroActive = false; });
    };

    $scope.refreshAvtalegiroStates = function (settings) {
        refreshStates(settings, function(status) { status.AvtalegiroActive = false; });
    };
    
    $scope.refreshiDEALStates = function (settings) {
        refreshStates(settings, function (status) { status.iDEALActive = false; });
    };

    function sortNumber(a, b) {
        return a - b;
    }

    $scope.addMaxDebitAmount = function (newMaxDebitAmount) {
        var value = parseInt(newMaxDebitAmount);
        if ((isNaN(value)) || (value < 1))
            return;
        if (typeof $scope.settings.MaxDebitAmounts == 'undefined' ||
            $scope.settings.MaxDebitAmounts.length == 0) {
            $scope.settings.MaxDebitAmounts = [];
            $scope.settings.MaxDebitAmountDefault = value;
        }
        else {
            for (var i = 0; i < $scope.settings.MaxDebitAmounts.length; i++) {
                if ($scope.settings.MaxDebitAmounts[i] == value)
                    return;
            }
        }
        $scope.settings.MaxDebitAmounts.push(value);
        $scope.settings.MaxDebitAmounts.sort(sortNumber);
    };

    $scope.whiteLabelProviders = function(provider) {
        return provider.IsDebitProvider ||
            provider.IsCreditCardProvider ||
            provider.IsOnAccountProvider ||
            provider.IsBetalingsserviceProvider ||
            provider.IsAutogiroProvider ||
            provider.IsAvtalegiroProvider;            
    };

    $scope.useCustomDDPrenotificationPolicyChanged = function() {
        if (!$scope.settings.UseCustomDDPrenotificationPolicy) {
            $scope.settings.InitialDDPrenotificationDays = 5;
            $scope.settings.RecurringDDPrenotificationDays = 2;
        }
    };
};

PaymentProviderChargeBackFeesSettingsController.$inject = ['$scope', '$location', '$routeParams', '$http', 'PaymentProviderSettings','$rootScope'];
